module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/pleasant/25132ecd0aa6f9da233dc7c3cc373a80.png";